import { baseUrl } from "@/config/env";
import request from "@/router/axios";
import { parseParam } from "@/util/util";
/**
 * 解除订单员关联
 * @param {Object} data - 解除数据
 * @param {string} data.businessEntityId - 经营主体ID，必需
 * @param {string} data.openId - 订单员ID，必需
 */
export const removeOrdererBinding = (data) => {
  console.log("businessEntity.js ~ line: 11 ~ data ->", data);
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/openIdEntityBind/${data.id}`,
    method: "DELETE",
  });
};
/**
 * 关联订单员
 * @param {Object} data - 关联数据
 * @param {string} data.businessEntityId - 经营主体ID，必需
 * @param {string} data.oprnId - 订单员ID，必需
 */
export const bindOrderer = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/openIdEntityBind`,
    method: "POST",
    data: data,
  });
};
/**
 * 查询已关联订单员列表
 * @param {Object} params - 查询参数
 * @param {string} params.businessEntityId - 经营主体ID，必需
 */
export const getOrdererList = (params) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/openIdEntityBind/${params.businessEntityId}`,
    method: "GET",
  });
};
/**
 * 查询经营主体列表
 * @param {Object} params - 查询参数
 * @param {string} params.page - 页码，必需，示例: 1
 * @param {string} params.size - 每页数量，必需，示例: 10
 * @param {string} params.entityName - 经营主体名称
 */
export const getBusinessEntityList = (params) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/businessEntity?${parseParam(params)}`,
    method: "GET",
  });
};

/**
 * 新增经营主体
 * @param {Object} data - 新增数据
 * @param {string} data.entityName - 经营主体名称，必需
 */
export const addBusinessEntity = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/businessEntity`,
    method: "POST",
    data: data,
  });
};

/**
 * 修改经营主体
 * @param {Object} data - 修改数据（原封不动传回去）
 */
export const updateBusinessEntity = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/businessEntity`,
    method: "PUT",
    data: data,
  });
};

/**
 * 删除经营主体
 * @param {string|Array} ids - 经营主体ID，格式为 "1,2,3" 或数组 [1,2,3]
 */
export const deleteBusinessEntity = (ids) => {
  // 确保ids是字符串格式
  let idsStr = ids;
  // 如果ids是数组，将其转换为逗号分隔的字符串
  if (Array.isArray(ids)) {
    idsStr = ids.join(",");
  } else if (typeof ids !== "string") {
    // 如果是其他类型，转换为字符串
    idsStr = String(ids);
  }

  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/businessEntity/${idsStr}`,
    method: "DELETE",
  });
};
/**
 * 商户列表
 * @param {Object} params - 查询参数
 * @param {string} params.businessEntityId - 经营主体ID，必需
 */
export const getShopsList = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/binding/listV2`,
    method: "GET",
    params: data,
  });
};

/**
 * 关联商户
 * @param {Object|Array} data - 关联数据，可以是单个对象或对象数组
 * @param {string} data.shopId - 商户ID，必需
 * @param {string} data.businessEntityId - 经营主体ID，必需
 * @param {string} data.shopMobile - 商户手机号
 * @param {string} data.shopName - 商户名称
 */
export const addShopEntityBind = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/shopEntityBind`,
    method: "POST",
    data: data,
  });
};

/**
 * 查询经营主体关联的商户
 * @param {string} businessEntityId - 经营主体ID，必需
 * @param {Object} params - 查询参数
 * @param {string} params.page - 页码
 * @param {string} params.size - 每页数量
 * @param {string} params.shopName - 商户名称
 */
export const getBusinessEntityShops = (businessEntityId, params = {}) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/shopEntityBind/${businessEntityId}?${parseParam(
      params,
    )}`,
    method: "GET",
  });
};

/**
 * 删除经营主体关联的商户
 * @param {Object} params - 删除参数
 * @param {string} params.id - 经营主体ID，必需
 */
export const deleteShopEntityBind = (params) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/shopEntityBind/${params.id}`,
    method: "DELETE",
  });
};
